
import { configureStore, Action } from '@reduxjs/toolkit'
import { ThunkAction } from 'redux-thunk'
// Or from '@reduxjs/toolkit/query/react'
import { setupListeners } from '@reduxjs/toolkit/query'
import { alarmApi } from '../services/alarm'
import { alarmClassApi } from '../services/alarmClasses'
import { objectsApi, objectClassesApi } from '../services/objects'
import { historicalDataApi } from '../services/historicalData'
import { bacnetMappingApi } from '../services/mapping/bacnet/bacnetMappingApi'
import { objectsTemplatesApi} from '../services/objectsTemplates/objectsTemplatesApi'
import { bacnetPropertyMappingApi } from '../services/mapping/bacnet/bacnetPropertyMappingApi'
import { bacnetStateApi } from '../services/mapping/bacnet/bacnetStateApi'
import { graphApi } from '../services/msgraph/msGraphApi'
import { errorMiddleware } from '../services/errorMiddleware'
import { resourceGroupApi } from '../services/resourceGroups/resourceGroupApi'
import { subscriptionApi } from '../services/resourceGroups/subscriptionApi'
import { tenantAPi } from '../services/resourceGroups/tenantApi'
import { alarmHubApi } from '../services/alarm/alarmHubApi'
import { objectHubApi } from '../services/objects/objectHubApi'
import { userApi } from '../services/resourceGroups/userApi'
import { notificatonsApi } from '../services/notifications/notificationsApi'
import { energyMetersApi } from '../services/energyMeters'
import { energyHeatmapApi } from '../services/energyHeatmap'
import { userInteractionsApi } from '../services/userInteractions'
import { schedulersApi } from '../services/schedulers'
import { objectModelsApi } from '../services/objects/objectModelsApi'



const store =
  configureStore({
    reducer: {
      // Add the generated reducer as a specific top-level slice
      [alarmApi.reducerPath]: alarmApi.reducer,
      [alarmClassApi.reducerPath]: alarmClassApi.reducer,
      [objectsApi.reducerPath]: objectsApi.reducer,
      [historicalDataApi.reducerPath]: historicalDataApi.reducer,
      [bacnetMappingApi.reducerPath]: bacnetMappingApi.reducer,
      [bacnetPropertyMappingApi.reducerPath]: bacnetPropertyMappingApi.reducer,
      [objectsTemplatesApi.reducerPath] : objectsTemplatesApi.reducer,
      [objectClassesApi.reducerPath]: objectClassesApi.reducer,
      [graphApi.reducerPath]: graphApi.reducer,
      [bacnetStateApi.reducerPath]: bacnetStateApi.reducer,    
      [resourceGroupApi.reducerPath]: resourceGroupApi.reducer,       
      [subscriptionApi.reducerPath]: subscriptionApi.reducer,    
      [tenantAPi.reducerPath]: tenantAPi.reducer,    
      [alarmHubApi.reducerPath]: alarmHubApi.reducer,  
      [objectHubApi.reducerPath]: objectHubApi.reducer, 
      [userApi.reducerPath]: userApi.reducer, 
      [notificatonsApi.reducerPath]: notificatonsApi.reducer, 
      [energyMetersApi.reducerPath]: energyMetersApi.reducer,
      [schedulersApi.reducerPath]: schedulersApi.reducer,
      [objectModelsApi.reducerPath]: objectModelsApi.reducer,
      [energyHeatmapApi.reducerPath]: energyHeatmapApi.reducer,
      [userInteractionsApi.reducerPath]: userInteractionsApi.reducer,
      
    },
    // Adding the api middleware enables caching, invalidation, polling,
    // and other useful features of `rtk-query`.
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware()
        .concat(alarmApi.middleware)
        .concat(alarmClassApi.middleware)
        .concat(objectsApi.middleware)
        .concat(historicalDataApi.middleware)
        .concat(bacnetMappingApi.middleware)
        .concat(bacnetPropertyMappingApi.middleware)
        .concat(objectsTemplatesApi.middleware)
        .concat(objectClassesApi.middleware)
        .concat(graphApi.middleware)
        .concat(bacnetStateApi.middleware)
        .concat(resourceGroupApi.middleware)
        .concat(subscriptionApi.middleware)
        .concat(tenantAPi.middleware)
        .concat(objectHubApi.middleware)
        .concat(alarmHubApi.middleware)
        .concat(userApi.middleware)
        .concat(notificatonsApi.middleware)
        .concat(energyMetersApi.middleware)
        .concat(schedulersApi.middleware)
        .concat(objectModelsApi.middleware)
        .concat(energyHeatmapApi.middleware)
        .concat(userInteractionsApi.middleware)
        .concat(errorMiddleware)
  })


// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch
export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>

export default store